export const SupportStatusCellRenderer = (props) => {
  const { value } = props;

  if (!value) return null;

  const getStatusColor = (status) => {
    switch (status) {
      case "Destek Verildi":
        return "#10B981"; // Yeşil - görseldeki gibi
      case "Çağrı cevaplandı":
        return "#14B8A6"; // Teal
      case "Çağrı yanıtlanmadı":
        return "#F59E0B"; // Turuncu
      case "Ar-Ge'ye iletildi":
        return "#3B82F6"; // Mavi
      case "Destek verilemedi":
        return "#EF4444"; // Kırmızı
      default:
        return "#6B7280"; // Gri
    }
  };

  return (
    <div
      style={{
        backgroundColor: getStatusColor(value),
        color: "white",
        padding: "6px 12px",
        borderRadius: "4px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.875rem",
        fontWeight: 500,
        minWidth: "120px",
        textAlign: "center",
      }}
    >
      {value}
    </div>
  );
};
